var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-panel-title"},[_c('div',{staticStyle:{"width":"3rem"}},[_c('h5',[_vm._v(_vm._s(_vm.index))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-right":"2rem"}},[_c('h5',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }